import { render } from "./dimensionOption.vue?vue&type=template&id=a848d7de"
import script from "./dimensionOption.vue?vue&type=script&lang=js"
export * from "./dimensionOption.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__